import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ typography, spacing, colors, grid }) => css`
    position: relative;
    width: 440px;
    @media (max-width: ${grid.breakpoint.sm}) {
      width: 100%;
    }

    div {
      > h2 {
        ${typography.headingLarge};
        line-height: ${spacing.md};
        color: ${colors.neutral[900]};
      }

      > p {
        ${typography.paragraphSmall};
        margin: ${spacing.xxs} 0 ${spacing.sm};
        color: ${colors.neutral[700]};
      }
    }
  `,

  buttonWrapper: ({ spacing }) => css`
    margin-top: ${spacing.sm};
  `,

  linkSupport: ({ colors, spacing }) => css`
    color: ${colors.background.white};
    margin-top: ${spacing.xs};
    cursor: pointer;
    position: relative;
    @media screen and (max-width: 768px) {
      margin: ${spacing.md};
    }
    &:hover {
      color: ${colors.background.white};
    }
  `,
})

export default useStyles
